function initNavbarPublicContent() {
  const navItemsContainer = document.getElementById("navbar-public-content-nav-items");
  if (!navItemsContainer) {
    return;
  }

  const items: NodeListOf<HTMLElement> = navItemsContainer.querySelectorAll(":scope > a");
  if (items.length == 0) {
    return;
  }

  scrollToSelectedItem(navItemsContainer, items);
}

function scrollToSelectedItem(container: HTMLElement, items: NodeListOf<HTMLElement>): void {
  if (!hasSelectedItem(items)) {
    return;
  }

  let scrollToPosition = 0;

  for (const item of items) {
    if (item.hasAttribute("selected")) {
      scrollToPosition += item.offsetWidth / 2;
      break;
    }

    scrollToPosition += item.offsetWidth;
  }

  scrollToPosition -= container.offsetWidth / 2;

  container.scroll({ left: scrollToPosition, behavior: "auto" });
}

function hasSelectedItem(items: NodeListOf<Element>): boolean {
  for (const item of items) {
    if (item.hasAttribute("selected")) {
      return true;
    }
  }

  return false;
}

document.addEventListener("DOMContentLoaded", initNavbarPublicContent);
